import { Badge } from "react-bootstrap";

const emailLogsTableColumn = [
    {
        Header: "S.no",
        width: "70",
    },
    {
        Header: "Module",
        accessor: "module",
    },
    {
        Header: "Subject",
        accessor: "subject",
    },
    {
        Header: "Sent to name",
        accessor: "sent_to_name",
    },
    {
        Header: "Sent to email",
        accessor: "sent_to_email",
        width: "300",
    },
    {
        Header: "From email",
        accessor: "from_email",
        width: "300",
    },
    {
        Header: "CC email",
        accessor: "cc_email",
    },
    {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => {
            const isSuccess = value === 1;

            return (
                <Badge bg={isSuccess ? "success" : "danger"}>
                    {isSuccess ? "Success" : "Failed"}
                </Badge>
            );
        },
    },
    {
        Header: "Sent At",
        accessor: "created_at",
    },
];

export { emailLogsTableColumn };
